export function isValidPaymentLinkId(paymentLinkId: string) {
  const paymentLinkIdRegex = /pl_(\S{32})$/gm;
  return paymentLinkIdRegex.test(paymentLinkId);
}
